import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import users from './modules/users';
import company from './modules/company'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users,
    company,
  },
  plugins: [createPersistedState()],
  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/vuex/store.js